import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import getAPIUrl from './helpers/getAPIUrl'

Vue.config.productionTip = false

// Detectar si estamos en Electron
const isElectron = typeof process !== 'undefined' && process.type === 'renderer'

if (isElectron) {
  // En Electron, la URL se maneja desde App.vue a través de background.js
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
} else {
  // En web, esperar a que se cargue connWeb.json antes de iniciar Vue
  getAPIUrl()
    .then(url => {
      store.commit('setApiUrl', url)

      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error('Error cargando connWeb.json:', err)
    })
}
